/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractGridInputCellEditorComponent } from './abstract-grid-input-cell-editor.component';

@Component({
  standalone: false,
  selector: 'gh-grid-masked-cell-editor',
  templateUrl: 'grid-masked-cell-editor.component.html',
  styleUrls: ['grid-input-cell-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridMaskedCellEditorComponent extends AbstractGridInputCellEditorComponent {
}
